import { Person } from '@mui/icons-material';
import {
  FormControl,
  FormHelperText,
  Grid2,
  InputLabel,
  ListItemIcon,
  MenuItem,
  Select,
  Skeleton
} from '@mui/material';
import { Template } from '@thro-types/notification';

import { t } from 'i18next';
import { Dispatch, SetStateAction } from 'react';

import LeihBar from 'assets/leihBar_Logo.svg';
import { translations } from 'locales/i18n';

interface Props {
  templates: Template[] | undefined;
  selectedTemplate: string;
  setSelectedTemplate: Dispatch<SetStateAction<string>>;
}

export const TemplateSelect = ({ templates, selectedTemplate, setSelectedTemplate }: Props) => {
  const templatesToExclude = ['cancelOrderForLender', 'cancelOrderForBorrower'];
  const lenderTemplates = ['newOrder', 'cancelBookingForLender', 'articleSkuChange']; // ! Order of these is important to the customer

  const orderOfTemplates = [
    'bookingUpdate',
    'orderSummary',
    'returnReminder',
    'collectionConfirmation',
    'cancelBookingForBorrower',
    ...lenderTemplates
  ]; // ! Order of these is important to the customer

  const renderSelect = (templates?: Template[]) => {
    if (!templates) return [];

    return templates
      ?.filter(template => !templatesToExclude.includes(template.name))
      .sort((a, b) => orderOfTemplates.indexOf(a.name) - orderOfTemplates.indexOf(b.name))
      .map(template => (
        <MenuItem key={template.name} value={template.name}>
          <ListItemIcon>
            {lenderTemplates.includes(template.name) ? (
              <img src={LeihBar} width={24} alt="leihbar-icon" />
            ) : (
              <Person />
            )}
          </ListItemIcon>
          {translations.pages.leihbarMailSettings.templateNames[template.name]
            ? t(translations.pages.leihbarMailSettings.templateNames[template.name]())
            : template.name}
        </MenuItem>
      ));
  };

  if (!templates) return <Skeleton width={200} />;

  return (
    <FormControl>
      <InputLabel>{t(translations.pages.leihbarMailSettings.templateNameLabel())}</InputLabel>
      <Select
        sx={{ minWidth: '16em' }}
        value={selectedTemplate}
        onChange={e => setSelectedTemplate(e.target.value)}
        label={t(translations.pages.leihbarMailSettings.templateNameLabel())}
        size="small"
        slotProps={{
          input: { sx: { alignItems: 'center', display: 'flex' } }
        }}
      >
        {renderSelect(templates)}
      </Select>
      <FormHelperText sx={{ fontSize: '0.8em', justifyContent: 'space-between' }}>
        <Grid2 container gap={1} justifyContent={'space-between'}>
          <Grid2 container gap={1}>
            <Person fontSize="small" />
            {t(translations.pages.leihbarMailSettings.templateNameHelperToBorrower())}
          </Grid2>
          <Grid2 container gap={1}>
            <img src={LeihBar} width={20} alt="leihbar-icon" />
            {t(translations.pages.leihbarMailSettings.templateNameHelperToLender())}
          </Grid2>
        </Grid2>
      </FormHelperText>
    </FormControl>
  );
};
